import PopupBase from "@luminecence/composants/PopupBase"
import { html } from "lit"

export default class PopupAjoutAmi extends PopupBase {
  static properties = {
    nom: { type: String },
    erreur: { type: String },
    commentaire: { type: String },
  }
  static styles = PopupBase.styles

  constructor() {
    super()
    this.nomAmi = ""
    this.erreur = ""
    this.commentaire = ""
  }

  render() {
    return html`
        <div class="conteneur">
            <h1>Ajouter un commentaire</h1>
            ${this.genererTemplateErreur()}
            <div class="formulaire">
                <div class="libelle-champ"><label>commentaire</label><textarea rows="4" @change=${this.changerCommentaire}>${this.commentaire}</textarea></div>
            </div>
        </div>
        ${this.renderBoutons()}
        `
  }

  genererTemplateErreur() {
    return this.erreur ? html`<span class="erreur">${this.erreur}</span>` : ""
  }

  valider() {
    this.dispatchEvent(
      new CustomEvent("valider", {
        bubbles: true,
        composed: true,
        detail: { commentaire: this.commentaire },
      }),
    )
    this.fermerPopup()
  }

  annuler() {
    this.dispatchEvent(
      new CustomEvent("valider", {
        bubbles: true,
        composed: true,
        detail: false,
      }),
    )
    this.fermerPopup()
  }

  changerCommentaire(event) {
    this.commentaire = event.target.value
  }
}

customElements.define("p-popup-ajout-ami", PopupAjoutAmi)
